import { StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        width: isWeb ? 720 : '100%',
        alignItems: 'center',
        marginHorizontal: isWeb ? 'auto' : 0,
        paddingHorizontal: widthPercentageToDP(16, 44, 0),
    },
    list: {
        width: '100%',
    },

    contentContainer: {
        flexGrow: 1,
        paddingTop: isWeb ? heightPercentageToDP(16) : 0,
    },
    emptyProgramsContainer: {
        opacity: 0.7,
        margin: 'auto',
    },
});

export default styles;
